import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  width: 230px;
  height: 56px;
  border-radius: 10px;
  border: 0;
  background: #eea302;
  margin-bottom: 16px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:not(:disabled):hover {
    background: ${shade(0.2, '#eea302')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
